import { get, post } from "../common/dataFetch";
import { Banner } from "../store/banner";
import { WebControllers } from "../constants/webControllers";
import { WebActionNames } from "../constants/webActionNames";

export const readActive = () => get<Banner>(WebControllers.Banner, WebActionNames.ReadActive);

export const upsertActive = (banner: Omit<Banner, "id">) => post(WebControllers.Banner, WebActionNames.UpsertActive, banner);